import { ICommentItem } from '@/interfaces/comment';
import React, { useMemo, useState } from 'react';
import defaultAvatar from '@/assets/images/defaultAvartar.png';
import Image from 'next/image';
import format from '@/utils/format';
import { BlackLikeIcon, LikedIcon } from '@/assets/icons';
import CommentInput from './CommentInput';
import { useUser } from '@/contexts/AuthContext';
import CommentEditInput from './CommentEditInput';

const CommentItem = ({
  data,
  onUpdate,
  onDelete,
  onSubmit,
  level = 1,
  onLikeClick,
  onUnLikeClick,
}: ICommentItem) => {
  const { user } = useUser();
  const {
    content,
    createdAt,
    createdBy,
    children,
    postId,
    id,
    parentCommentId,
    comments_likes_count,
    comments_likes,
  } = data || {};

  const isUserLiked = useMemo(
    () =>
      comments_likes?.some(
        (commentLike: any) =>
          commentLike?.created_by_id === Number(user?.userId),
      ),
    [comments_likes, user?.userId],
  );
  const [isReplyInput, setIsReplyInput] = useState(false);
  const [isShowReply, setIsShowReply] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  return (
    <>
      <div className="flex gap-4 pb-7">
        <div className="w-[37px] h-[37px] min-w-[37px] relative overflow-hidden">
          <Image src={defaultAvatar} alt="avatar" fill />
        </div>
        <div className="flex flex-col gap-2 pt-2 w-full">
          <div className="font-bold">
            {createdBy?.firstName ?? createdBy?.email}
          </div>
          {!isEditing ? (
            <div className="font-normal">{content}</div>
          ) : (
            <CommentEditInput
              onSubmit={content => {
                onUpdate(id, content);
                setIsEditing(false);
              }}
              initValue={content || ''}
              onCancel={() => setIsEditing(false)}
            />
          )}
          <div className="flex lg:gap-7 gap-3 text-[14px] lg:text-[16px] items-center">
            <div className="flex gap-1 items-center cursor-pointer hover:scale-105">
              {!isUserLiked ? (
                <BlackLikeIcon onClick={() => onLikeClick(id)} />
              ) : (
                <LikedIcon onClick={() => onUnLikeClick(id)} />
              )}
              {comments_likes_count?.count}
            </div>
            <div
              className="cursor-pointer hover:text-primary whitespace-nowrap"
              onClick={() => setIsReplyInput(!isReplyInput)}
            >
              Trả lời
            </div>
            <div className="">{format.formatDateMinus(createdAt)}</div>
          </div>
          {isReplyInput && (
            <div>
              <CommentInput
                onSubmit={comment => {
                  onSubmit(comment, postId, level === 2 ? parentCommentId : id);
                  setIsReplyInput(false);
                }}
              />
            </div>
          )}
          {children && children?.length > 0 && (
            <div
              className="cursor-pointer text-Grey underline hover:text-primary"
              onClick={() => setIsShowReply(!isShowReply)}
            >
              {isShowReply === false
                ? `Xem ${children?.length} phản hồi`
                : 'Ẩn phản hồi'}
            </div>
          )}
        </div>
        {createdBy?.id?.toString() === user?.userId && (
          <div className="whitespace-nowrap pt-2 flex flex-col items-end">
            <div
              onClick={() => setIsEditing(true)}
              className="cursor-pointer hover:text-primary"
            >
              Chỉnh sửa
            </div>
            <div
              onClick={() => onDelete(id)}
              className="cursor-pointer text-red-500 hover:text-red-900"
            >
              Xoá
            </div>
          </div>
        )}
      </div>

      {children &&
        children?.length > 0 &&
        isShowReply &&
        children?.map((item, index) => (
          <div key={index} className="pl-12">
            <CommentItem
              onUnLikeClick={onUnLikeClick}
              onUpdate={onUpdate}
              level={level + 1}
              onDelete={onDelete}
              onSubmit={onSubmit}
              onLikeClick={onLikeClick}
              data={item}
            />
          </div>
        ))}
    </>
  );
};

export default CommentItem;
